import * as types from "./types";
import { BookingService } from "../services/booking-service";
import * as AppActionTypes from "../../../store/app/types";
import { DataStates } from "../../../store/global/data-state";
import { HttpLib } from "../../../services/http/http-lib";

import * as D from "date-fns";
import { createHttpGetOptions, HttpClient } from "../../../services/http/http-client";
import { requestCancellationErrorHandler, REQUEST_CANCELLED } from "../../../services/http/error-handler";
import { validateResponse } from "../../../services/http/response-validator";
import { startDateView } from "../models/booking-overview.model";
import { createDropdownItem } from "../models/booking-artist.model";
import { createMailHref } from "../../../utility";
import { SignedDocumentTypes } from "../models/document.model";
import { bookingsActions } from "./bookings/actions";
import { artistActions } from "./artists/actions";
import { bookingPromotersActions } from "./promoters/actions";
import { bookingReportsActions } from "./reports/actions";
import { venueActions } from "./venues/actions";
import { bookingPluginsActions } from "./plugins/actions";
import { templateActions } from "./templates/actions";

import { toursActions } from './tours/actions'
import { BookingModulePluginStore } from "./plugins";
let fetchBookingListTokenSource = null;

export const actions = {
  ...bookingsActions,

  ...artistActions,
  ...bookingPromotersActions,
  ...bookingReportsActions,
  ...venueActions,

  ...BookingModulePluginStore.actions,

  ...toursActions,
  ...templateActions
};


const eitherCalendarDateId = (calendarDateId, getter) => {
  if (calendarDateId) {
    return calendarDateId;
  } else {
    if (getter.calendarDateId) {
      return getter.calendarDateId;
    } else {
      throw Error("Selected calendar not set!");
    }
  }
};
